import { AxiosInstance } from "../utils/AxiosInstance";
import axios from "axios";
import { API } from "../constants/api";
import {
  PFRequestData,
  PMRequestData,
} from "js/components/ExpressReport/types";

import { safeLocalStorage } from "@/utils/safeStorage";

export const getCreditReport = async (reportId: string) => {
  const { data } = await axios.get(`${API}/v2/reports/${reportId}`);
  return data;
};

export const startPfCreditReport = async (
  reportId: string,
  reportData: PFRequestData,
) => {
  const isGuarantor = !!safeLocalStorage.getItem(`is-guarantor-${reportId}`);
  const isGuarantorQuery = isGuarantor ? "?is_guarantor=true" : "";

  const { data } = await axios.put(
    `${API}/v2/reports/pf/${reportId}${isGuarantorQuery}`,
    reportData,
  );
  return data;
};

export const startPmCreditReport = async (
  reportId: string,
  reportData: PMRequestData,
) => {
  const isGuarantor = !!safeLocalStorage.getItem(`is-guarantor-${reportId}`);
  const isGuarantorQuery = isGuarantor ? "?is_guarantor=true" : "";

  const { data } = await axios.put(
    `${API}/v2/reports/pm/${reportId}${isGuarantorQuery}`,
    reportData,
  );
  return data;
};

export const confirmPinCreditReport = async (
  reportId: string,
  pin: string,
  confirmPin: string,
) => {
  const isGuarantor = !!safeLocalStorage.getItem(`is-guarantor-${reportId}`);
  const isGuarantorQuery = isGuarantor ? "?is_guarantor=true" : "";

  const { data } = await axios.post(
    `${API}/v2/reports/${reportId}/confirm-pin${isGuarantorQuery}`,
    {
      pin: pin,
      confirm_pin: confirmPin,
    },
  );
  return data;
};

export const resendPinCreditReport = async (
  reportId: string,
  method: string,
) => {
  const { data } = await axios.post(
    `${API}/v2/reports/${reportId}/resend-pin`,
    {
      method: method,
    },
  );
  return data;
};

export const enableCreditReport = async (reportId: string) => {
  const { data } = await AxiosInstance.put(
    `/v1/investigations/${reportId}/enable`,
  );
  return data;
};

export const disableCreditReport = async (reportId: string) => {
  const { data } = await AxiosInstance.put(
    `/v1/investigations/${reportId}/disable`,
  );
  return data;
};
